<template>
  <div>
    <button type="button" @click="open()" class="btn_print">Print</button>
    <div ref="printView">
      <div v-if="active" class="configurator-summary-print">
        <main>
          <div class="product">
            <div class="img">
              <img
                v-if="product.thumbnail.src"
                :src="product.thumbnail.src.url"
                :srcset="product.thumbnail.srcset"
                :alt="product.title"
              />
            </div>
            <div class="txt">
              <h5>{{ product.family }}</h5>
              <h4>{{ product.title }}</h4>
              <h6 v-if="showConfiguratorPricing">
                Estimated Total: {{ currencyFormatter(runningTotal) }}
                <div class="total-note">Tariff surcharges and associated fees are not included</div>
              </h6>
            </div>
          </div>
          <sku :product="product" :selections="selections"></sku>
          <div class="desc">
            <ul class="steps">
              <li
                v-for="(step, index) in product.steps"
                :key="step.id"
                class="option"
                :class="labelForStep(step)"
              >
                <span class="header">
                  <span class="num">
                    <i>{{ index + 1 }}</i>
                  </span>
                  <span class="txt">
                    <b>{{ step.title }}</b>
                  </span>
                </span>
                <span class="options">
                  <span
                    v-for="option in step.options"
                    :key="option.sku"
                    class="label"
                  >
                    <input
                      type="checkbox"
                      :value="option.sku"
                      :name="`${option.step_id}[]`"
                      :checked="isOptionSelected(option)"
                      :disabled="!isOptionSelected(option)"
                    />
                    <i>{{ option.label }} &ensp;</i>
                    <em v-if="option && option.price && showConfiguratorPricing" class="option-price">
                      {{ `[${currencyFormatter(option.price)}]` }}
                    </em>
                  </span>
                </span>
              </li>
            </ul>
          </div>
        </main>

        <footer>
          <img
            :src="`${url}/assets/images/theme/logo-lightart.svg`"
            alt="LightArt Logo"
          />

          <span class="address">
            4770 Ohio Ave South, Suite A, Seattle, WA 98134<br />
            P: 206.524.2223 | LightArt.com
          </span>

          <span class="product">{{ product.familyAssociation }} | {{ product.title }}</span>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import currencyFormatter from "../../../currency_formatter";
import Sku from "../Sku";

export default {
  components: {
    Sku,
  },
  props: ["product", "selections", "runningTotal", "showConfiguratorPricing"],
  data() {
    return {
      ref: null,
      active: false,
      currencyFormatter,
      url: `${window.location.protocol}//${window.location.hostname}${window.location.port ? ":" + window.location.port : ""}`,
    };
  },
  methods: {
    open() {
      this.active = true;
      this.ref = window.open(
        "",
        "",
        "width=850, height=1100, left=200, top=200"
      );

      this.ref.addEventListener("beforeunload", this.close);
      this.ref.document.title = "LightArt | Print your Configured SKU";
      this.ref.document.querySelector("head").innerHTML += `<link rel="stylesheet" href="${this.url}/assets/styles.css" type="text/css"/>`;
      this.ref.document.body.appendChild(this.$refs.printView);

      setTimeout(() => {
        this.ref.print();
      }, 500);
    },
    close() {
      if (this.ref) {
        this.ref.close();
        this.ref = null;
        this.$emit("closed");
      }
    },
    isOptionSelected(option) {
      let selectedId = this.selections[option.step_id] ? this.selections[option.step_id].internal : null;
      return option.internal_id === selectedId;
    },
    labelForStep(step) {
      if (step.options.length > 15) {
        return "lots";
      } else if (step.options.length > 10) {
        return "many";
      } else if (step.options.length > 5) {
        return "few";
      }
      return "";
    },
  },
  mounted() {
    if (this.active) {
      this.open();
    }
  },
  beforeDestroy() {
    if (this.ref) {
      this.close();
    }
  },
};
</script>
